// extracted by mini-css-extract-plugin
module.exports = {"norms_table":"NormsTable_norms_table__2zIVT"};